import styled from 'styled-components'

import * as colors from '../../constants/colors'

import { Message } from './field'

const colorByScore = {
  worst: colors.SECONDARY_RED_500,
  bad: colors.SECONDARY_RED_500,
  weak: colors.BRAND_INDIGO,
  good: colors.BRAND_INDIGO,
  strong: colors.PRIMARY_BLUE_500,
}

export const Indicator = styled(Message)`
  color: ${colors.TEXT_SECONDARY};
`

export const Strength = styled.span<{ $score: keyof typeof colorByScore }>`
  color: ${(props) => colorByScore[props.$score]};
`
